<template>
    <div class="common-container-fluid">
        <div class="common-title-content">
            <div class="title">
                <el-breadcrumb separator=">" class="uni-breadcrumb">
                    <el-breadcrumb-item :to="{
                        path:`/trainCert/login`
                    }">培训认证</el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="common-page-content clearfix">
            <div class="title-style">
              <div class="is-line">
                <img class="avatar-icon" :src="require('../../assets/img/traning/avatar.png')" alt=""/>
                <div class="title-detail">
                  <div class="first-line is-line">
                    <div class="name">
                      <el-tooltip
                        :disabled="isShowNameTooltip"
                        effect="dark"
                        :content="certUserInfoDetail.name">
                        <div class="text-tip-wrap" @mouseover="setTitleWidth(certUserInfoDetail.name,'name')">
                          <span :ref="certUserInfoDetail.name">{{ certUserInfoDetail.name }}</span>
                            <slot></slot>
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="logout"  @click="logout">退出
                      <img src="../../assets/img/traning/logout.svg"  alt="">
                    </div>
                  </div>
                  <div class="second-line is-line">
                    <div class="phone">
                      <img src="../../assets/img/traning/phone.svg"  alt="">
                      手机号
                      <span class="info">{{ certUserInfoDetail.phone }}</span>
                    </div>
                    <div class="company">
                      <img src="../../assets/img/traning/company.svg"  alt="">
                      公司
                      <span class="info">
                        <el-tooltip
                          :disabled="isShowCompanyTooltip"
                          effect="dark"
                          :content="certUserInfoDetail.company">
                          <div class="text-tip-wrap" @mouseover="setTitleWidth(certUserInfoDetail.company,'company')">
                            <span :ref="certUserInfoDetail.company">{{ certUserInfoDetail.company }}</span>
                              <slot></slot>
                          </div>
                        </el-tooltip>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert">
              <img src="../../assets/img/traning/info.svg"  alt="">
              支持已认证用户查询培训证书。
            </div>
            <div  class="purple-stripe-text">
              <span class="purple-stripe"></span>
              证书信息
              <el-button class="refresh-style" type="primary" @click="refreshPage"><i class="el-icon-refresh"></i></el-button>
            </div>
            <div  class="certificate-module">
              <div  class="certificate-line">
                <div v-for="item in cerList" :key="item.id" class="certificate">
                    <div class="certificate-title">
                      {{ item.caNo }}
                    </div>
                    <div style="width: 100%;text-align: center;">
                        <el-button
                          type="text"
                          class="text-btn"
                          @click="exportExcal(item)"
                          >
                          <img class="btn-icon" src="../../assets/img/traning/download.svg"  alt=""/>
                          下载</el-button
                        >
                        <el-button
                          type="text"
                          class="text-btn"
                          @click="showPdf(item)"
                          >
                          <img class="btn-icon" src="../../assets/img/traning/pre.svg"  alt=""/>
                          预览</el-button
                        >
                    </div>
                    <div class="date-line">
                      <span class="date-title">认证日期:</span>
                      {{ item.caTime }}
                      <span style="margin-left: 23px;" class="date-title">有效日期:</span>
                      {{ item.caEffectiveDate }}
                    </div>
                </div>
              </div>
            </div>
      </div>
      <pdf-detail
        v-if="pdfDialogVisible"
        :pdfDialogVisible="pdfDialogVisible"
        @closeDialog="closePdf"
        :pdfRow="pdfRow"
        titleName=""
        :showClose="false"
      ></pdf-detail>
    </div>
</template>

<script>
  import trainingCertReq from '~/request/trainingReq';
  import pdfDetail from './pdfDetail.vue';

  import axios from 'axios'
  import { saveAs as FileSaver } from 'file-saver';
  export default {
    data() {
      return {
        pdfDialogVisible: false, //展示pdf
        isShowNameTooltip: true, //展示悬浮框
        isShowCompanyTooltip: true, //展示悬浮框
        pdfRow: {},
        pdfData: [],
        certUserInfoDetail: {
          company: "",
          id: "",
          name: "",
          phone: ""
        },
        cerList: [ {
          caNo: "",
          caTime: "",
          caEffectiveDate: "",
          caLevel: "",
          caStatus:""
        }],
        id:this.$route.query.id,
      };
    },
    computed: {
    },
    methods: {
      // 内容超出，显示文字提示内容
      setTitleWidth(val,type) {
        let tag = this.$refs[val];
        let contentWidth = tag.offsetWidth; // 获取元素可视宽度
        let falg = contentWidth <= 200;
        if(type == 'name') {
          this.isShowNameTooltip = falg;
        } else if(type == 'company') {
          this.isShowCompanyTooltip = falg;
        }
      },
      logout() {
        trainingCertReq
          .logout()
          .then(res => {
            if (Number(res.code) === 0 || Number(res.code) === 401) {
              localStorage.removeItem("token");
              localStorage.removeItem("userId");
              this.$router.push('/trainCert/login');
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      //导出Excal
      exportExcal(row) {
        let data = {
          idList: [row.caId],
        };
        this.getPdfUrl(data, 'export');
      },
      //获取pdf下载链接
      getPdfUrl(data, type) {
        trainingCertReq
          .download(data)
          .then(res => {
            if (Number(res.code) === 0) {
              if (type == 'export') {
                this.pdfData = res.res;
                if (this.pdfData.length == 1) {
                  this.downloadSinglePdf(this.pdfData);
                } else {
                  this.$notify({
                    title: '警告',
                    message: '没有有效的下载链接',
                    type: 'warning',
                  });
                }
              } else if (type == 'showPdf') {
                if (res.res && res.res[0]) {
                  this.pdfDialogVisible = true;
                  this.pdfRow = res.res[0];
                } else {
                  this.$notify({
                    title: '警告',
                    message: '证书临时无法查看。',
                    type: 'warning',
                  });
                }
              }
            } else if(Number(res.code) === 401) {
              localStorage.removeItem("token");
              localStorage.removeItem("userId");
              this.$router.push('/trainCert/login');
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      getFile(url){
        return new Promise((resolve, reject) => {
          axios({
            method: "get",
            url:url,
            responseType: "blob"
          })
            .then(data => {
              resolve(data.data);
            })
            .catch(error => {
              reject(error.toString());
            });
        });
      },
      //拼接为年月日时分秒
      getCurrentDateTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
      },
      //单个下载
      downloadSinglePdf(url) {
        if (url.length > 0) {
          let temp = url[0].split('/');
          let name = temp[temp.length - 1];
          name = decodeURI(name);
          const ajax = new XMLHttpRequest();
          ajax.open('GET', url[0], true);
          ajax.responseType = 'blob';
          ajax.onload = function () {
            const file = new Blob([ajax.response], { type: 'blob' });
            FileSaver.saveAs(file, name);
          };
          ajax.send();
        }
      },
      // 查看pdf
      showPdf(row) {
        let data = {
          idList: [row.caId],
        };
        this.getPdfUrl(data, 'showPdf');
        // this.pdfRow = row;
      },
      // 取消查看pdf
      closePdf() {
        this.pdfDialogVisible = false;
      },
      //获取详情
      getDetail(id) {
        let param = {
          'userId':id
        };
        trainingCertReq
          .getMyInfo(param)
          .then(res => {
            if (Number(res.code) === 0) {
              this.certUserInfoDetail = res.res;
            } else if(Number(res.code) === 401) {
              localStorage.removeItem("token");
              localStorage.removeItem("userId");
              this.$router.push('/trainCert/login');
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      getCerList(id) {
        let param = {
          'userId':id
        };
        trainingCertReq
          .getCerList(param)
          .then(res => {
            if (Number(res.code) === 0) {
              this.cerList = res.res;
            } else if(Number(res.code) === 401) {
              localStorage.removeItem("token");
              localStorage.removeItem("userId");
              this.$router.push('/trainCert/login');
            }
          })
          .catch(err => {
            console.error(err);
          });

      },
      refreshPage() {
        this.getDetail(this.$route.query.id);
        this.getCerList(this.$route.query.id);
      },

    },
    components: {
      'pdf-detail': pdfDetail,
    },
    mounted() {
      this.refreshPage();
    },
    created() {},
    filters: {},
  };
</script>

<style scoped>
  .common-title-content {
    width: 1200px;
    margin:22px auto 0px;
  }
  .common-title-content /deep/ span.el-breadcrumb__inner.is-link {
    font-weight: 400;
    font-size: 12px;
    color: #888888;
    line-height: 17px;
  }
  .common-title-content /deep/ span.el-breadcrumb__inner {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .common-title-content /deep/ span.el-breadcrumb__separator{
    margin: 0 !important;
  }
  .common-page-content {
    width: 1200px;
    margin:19px auto 29px;
    min-height: 920px;
    background: linear-gradient( 180deg, #F9F6FC 0%, #FFFFFF 100%);
    box-shadow: 0px 0px 28px 0px rgba(0,0,0,0.05);
    border: 2px solid;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 2 2;
  }
  .title-style {
    margin: 20px 24px 0;
    height: 157px;
    border-bottom: 1px solid #E3DEE8;
    background-image: url("../../assets/img/traning/titleright.png");
    background-position: right;  /* 靠右对齐 */
    background-repeat: no-repeat;  /* 不重复 */
    /* 可选补充属性 */
    background-size: contain;  /* 或 cover/具体尺寸，控制图片缩放 */
  }
  .title-detail {
    display: inline-grid;
  }
  .name {
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 33px;
    margin: 27px 34px 16px 3px;
  }
  .text-tip-wrap {
    max-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .logout {
    font-weight: 500;
    font-size: 14px;
    color: #9E0086;
    line-height: 20px;
    margin: 37px 0 14px;
    cursor: pointer;
  }
  .logout img {
    margin: -1px 3px;
    width: 12px;
    height: 12px;
  }
  .is-line {
    display: inline-flex;
  }
  .avatar-icon {
    width: 80px;
    height: 80px;
    margin: 20px 17px 37px;
  }
  .phone {
    width: 165px;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 17px;
  }
  .phone img {
    width: 14px;
    height: 14px;
    margin: 0px 6px 0 0;
    vertical-align: text-bottom;
  }
  .company {
    border-left: 1px solid #D2D2D2;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 17px;
    height: 17px;
  }
  .company img {
    width: 14px;
    height: 14px;
    margin: 0px 6px 0 20px;
    vertical-align: text-bottom;
  }
  .info {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    display: inline-flex;
  }
  .alert {
    width: 1152px;
    height: 44px;
    background: #F9EEF9;
    border-radius: 4px;
    border: 1px solid #961189;
    margin: 20px 24px;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.9);
    line-height: 44px;
    text-align: left;
    font-style: normal;
    display: inline-flex;
  }
  .alert img {
    margin: 12px 8px 12px 17px;
  }

  .purple-stripe-text {
    position: relative;
    padding-left: 10px;
    margin-left: 24px;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,0,0,0.9);
    line-height: 21px;
    text-align: left;
    font-style: normal;
  }
  .purple-stripe {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 5px;
    background: #961189;
    border-radius: 2px;
    opacity: 0.9;
    box-shadow: 0px 2px 4px 0px #FFFFFF;
  }
  .certificate-module {
    height: calc(100vh - 370px);
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 12px;
  }
  .certificate-line {
    margin: 20px -20px 0px 24px!important;
    display: flex;
    flex-wrap: wrap;
  }
  .certificate {
    background-image: url("../../assets/img/traning/infobg.png");
    background-position:center;  /* 靠右对齐 */
    background-repeat: no-repeat;  /* 不重复 */
    /* 可选补充属性 */
    background-size: cover;  /* 或 cover/具体尺寸，控制图片缩放 */
    width: 370px;
    height: 185px;
    border-radius: 4px;
    border: 1px solid #D5D5D5;
    margin: 0 20px 20px 0;
  }
  .certificate-title {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    text-align: center;
    margin: 33px auto 28px;
  }
  .date-line {
    font-weight: 500;
    font-size: 12px;
    color: #000000;
    line-height: 17px;
    text-align: center;
    font-style: normal;
    margin-top: 30px;
  }
  .date-title {
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.6);
  }
  .btn-icon {
    background-repeat: no-repeat;
    background-size: contain;
    width: 18px;
    height: 16px;
    background-position: center;
    vertical-align: text-bottom;
  }
  .refresh-style {
    float: right;
    margin-right: 20px;
  }
</style>

<style lang="less" scoped>
  .el-input {
    /deep/.el-input__suffix{
      font-size: 14px;
      padding: 0 3px;
      &:hover {
          cursor: pointer;
          color: #618afd;
        }
      }
    }
  .text-btn {
    color: @currentColor;
    font-weight: 400;
  }
</style>
